<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title">
            <template
                v-if="authorize('cadastro-limite-mensagem-store')"
                v-slot:actions
            >
                <rkm-button
                    :to="{name: 'cadastro-limite-mensagem-create'}"
                    color="primary"
                >
                    Cadastrar limite
                </rkm-button>
            </template>
        </rkm-content-header>

        <rkm-content-body>
            <rkm-container>
                <List />
            </rkm-container>
        </rkm-content-body>
    </rkm-content>
</template>

<script>
// Components.
import List from '@/components/cadastro/limite-mensagem/List'

// Mixins.
import {authorization} from '@/mixins'

export default {
    components: {List},
    mixins: [authorization],
}
</script>
